import {
  ChevronDownIcon,
  Collapsible,
  Flex,
  Heading,
  SimpleSpinner,
  Text,
} from '@buffer-mono/popcorn'

import type { Channel } from '~publish/gql/graphql'

import { useCommentsScore } from '../../hooks/useCommentsScore'
import { CommentScoreMetric } from '../../components/CommentScoreMetric'
import { DetailedMetrics } from '../../components/DetailedMetrics'

import styles from './CommentsScore.module.css'

export const CommentsScore = ({
  channel,
}: {
  channel: Channel
}): JSX.Element => {
  const { commentsScore, loading } = useCommentsScore({
    channelId: channel.id,
  })

  if (loading) return <SimpleSpinner />

  if (!commentsScore) return <Text>Error loading comments score.</Text>

  return (
    <>
      <CommentScoreMetric
        level={commentsScore.currentAchievementLevel}
        score={commentsScore.currentWeekScore.totalValue}
      />
      <Collapsible className={styles.collapsible}>
        <Collapsible.Trigger asChild className={styles.parentTrigger}>
          <Flex direction="row" justify="start">
            <Heading as="h4" size="xsmall">
              Detailed metrics
            </Heading>
            <ChevronDownIcon className={styles.triggerIcon} />
          </Flex>
        </Collapsible.Trigger>
        <Collapsible.Content>
          <DetailedMetrics
            responseRate={commentsScore.currentWeekScore.responseRate}
            responseSpeed={commentsScore.currentWeekScore.responseSpeed}
            consistency={commentsScore.currentWeekScore.consistency}
          />
        </Collapsible.Content>
      </Collapsible>
    </>
  )
}
